import React, { useEffect, useState } from 'react';
import './css/index.scss';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useInputState from '../../helpers/hooks/useInputState';
import PageTitle from '../../components/PageTitle';
import MyButton from '../../components/MyButton';
import PhotosPart from './components/PhotosPart';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../Api';

function EditEventPhotos() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('id');

  const [gettingError, setGettingError] = useState('');

  const [ownerId, setOwnerId] = useInputState();
  const [savedPhotos, setSavedPhotos] = useState([]);

  const onCancelClick = () => {
    navigate('/events/view');
  };

  const initData = async () => {
    const data = await sendRequest({
      request: Api.getEvent,
      payload: { id: eventId },
      warnErrorText: 'while getting single event',
    });

    if (data?.status !== 'ok') {
      setGettingError('Ошибка');
      return;
    }

    const selectedEvent = data.event;
    setOwnerId(selectedEvent.user._id);
    setSavedPhotos(selectedEvent.carousel_photos);
  };

  useEffect(() => {
    initData().then();
  }, []);

  return (
    <div className="edit_event_photos">
      <PageTitle
        text="Редактировать фото"
        RightComponent={(
          <div className="edit_event_photos_button_group">
            <MyButton
              text="Назад"
              onClick={onCancelClick}
              className="edit_event_photos_button_group_cancel"
              secondary
            />
          </div>
        )}
      />
      {gettingError
        ? <p className="edit_event_photos_info_text">{gettingError}</p>
        : (
          <div className="edit_event_photos_container">
            <PhotosPart
              savedPhotos={savedPhotos}
              ownerId={ownerId}
              initData={initData}
              eventId={eventId}
            />
          </div>
        )}
    </div>

  );
}

export default EditEventPhotos;
